document.addEventListener("turbo:load", function () {
  if ($("#kpis-container").length) {
    function updateRemoveButtons() {
      $(".kpi-fields").each(function () {
        const removeBtn = $(this).find(".remove-kpi");
        if ($(".kpi-fields").length > 1) {
          removeBtn.show();
        } else {
          removeBtn.hide();
        }

        if ($(".kpi-fields").length <= 3)
          $("#add-kpi").first().prop("disabled", false);
      });
    }

    $("#add-kpi").on("click", function () {
      // Maximum of 3 for now
      if ($(".kpi-fields").length >= 3) return;

      const newKpiField = $(".kpi-fields").first().clone();
      newKpiField.find("input").val("");
      newKpiField.find(".remove-kpi").show();
      $("#kpis-container").append(newKpiField);
      updateRemoveButtons();

      // Disable when the limit is reached.
      if ($(".kpi-fields").length >= 3)
        $("#add-kpi").first().prop("disabled", true);
    });

    $(document).on("click", ".remove-kpi", function () {
      $(this).closest(".kpi-fields").remove();
      updateRemoveButtons();
    });

    updateRemoveButtons();
  }
});
